import Grid from '@mui/material/Grid';
import SummaryCard from './SummaryCard';
import OrderFlowCard from './OrderFlowCard';
import ServiceStatusCard from './ServiceStatusCard';
import ServiceLogsCard from './ServiceLogsCard';

export default function DashboardContent() {
  return (
    <Grid container spacing={1}>
      <Grid item xs={4.5}>
        <SummaryCard />
      </Grid>
      <Grid item xs={7.5}>
        <OrderFlowCard />
      </Grid>
      <Grid item xs={4}>
        <ServiceStatusCard />
      </Grid>
      <Grid item xs={4}>
        <ServiceLogsCard />
      </Grid>
      <Grid item xs={4}></Grid>
    </Grid>
  );
}
